import { useCallback, useEffect } from "react";

export function useStickyBarLayout(barRef: React.RefObject<HTMLDivElement>) {
  const setLayoutHeights = useCallback(() => {
    const header = document.querySelector(
      '[data-testid="header-outerContainer"] > div:first-child',
    );

    const headerHeight = header?.clientHeight || 0;

    document.documentElement.style.setProperty(
      "--headerHeight",
      `${headerHeight}px`,
    );

    if (barRef.current) {
      const stickyHeight = barRef.current.clientHeight;
      document.documentElement.style.setProperty(
        "--newStickyHeight",
        `${headerHeight + stickyHeight}px`,
      );
    }
  }, [barRef]);

  useEffect(() => {
    setLayoutHeights();
    window.addEventListener("resize", setLayoutHeights);

    return () => {
      window.removeEventListener("resize", setLayoutHeights);
    };
  }, [setLayoutHeights]);

  return { setLayoutHeights };
}
